import { render, staticRenderFns } from "./PermitCustomMessage.vue?vue&type=template&id=ee5f883e"
import script from "./PermitCustomMessage.vue?vue&type=script&lang=js"
export * from "./PermitCustomMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports